import { Trans } from '@lingui/macro'
import SettingsIcon from '@mui/icons-material/Settings'
import {
  Dialog,
  DialogContent,
  FormControlLabel,
  IconButton,
  Tooltip
} from '@mui/material'
import { authRoles, hasRole } from 'app/auth/authRoles'
import { setTestingOptions } from 'app/redux/actions/TestingOptionsActions'
import { setUserData } from 'app/redux/actions/UserActions'
import Checkbox from 'app/views/common-components/CustomCheckbox'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DialogTitleWithIconClose } from '../common-components/DialogTitleWithIconClose'

export const TestingOptionsButton = () => {
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const dispatch = useDispatch()
  const showTranslationIds = useSelector((state) => state?.testingOptions?.showTranslationIds)
  const user = useSelector((state) => state?.user)
  const isTranslator = hasRole(user.role, authRoles.translator)
  const originalLanguageRef = React.useRef(null)

  useEffect(() => {
    if (!showTranslationIds) originalLanguageRef.current = null
  }, [showTranslationIds, user.language])

  const handleShowTranslationIdsChange = (checked) => {
    dispatch(setTestingOptions({ showTranslationIds: checked }))

    if (checked) {
      if (!originalLanguageRef.current && user.language && user.language !== 'fake') {
        originalLanguageRef.current = user.language
      }
      if (user.language !== 'fake') {
        dispatch(setUserData({ ...user, language: 'fake' }))
      }
    } else {
      const restore = originalLanguageRef.current || 'en'
      if (user.language === 'fake') {
        dispatch(setUserData({ ...user, language: restore }))
      }
      originalLanguageRef.current = null
    }
  }
  return (
    <>
      <Dialog
        open={dialogOpen}
        fullWidth
        maxWidth='xs'
      >
        <DialogTitleWithIconClose
          label={<Trans>TESTING_OPTIONS_DIALOG_TITLE</Trans>}
          handleClose={() => setDialogOpen(false)}
        />
        <DialogContent>
          {/* {isTester && <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(simulateInternal)}
                onChange={e => {
                  dispatch(setTestingOptions({ simulateInternal: e.target.checked }))
                }}
              />
                }
            label={<Trans>SIMULATE_INTERNAL_ENVIRONMENT_LABEL</Trans>}
                       />} */}
          {isTranslator && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(showTranslationIds)}
                  onChange={e => handleShowTranslationIdsChange(e.target.checked)}
                />
              }
              label={<Trans>TESTING_OPTIONS_SHOW_TRANSLATION_IDS</Trans>}
            />
          )}
        </DialogContent>
      </Dialog>
      <Tooltip title={<Trans>TESTING_OPTIONS_ICON_TOOLTIP</Trans>}>
        <span>
          <IconButton
            onClick={() => {
              setDialogOpen(true)
            }}
          >
            <SettingsIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </span>
      </Tooltip>

    </>
  )
}
